import { classes } from "lib/actions/util";
import React from "react";

const Card = ({
  children,
  hasShadow = true,
  className,
  onClick,
}: {
  children?: React.ReactNode;
  hasShadow?: boolean;
  className?: string;
  onClick?: (event: React.MouseEvent) => void;
}) => {
  return (
    <div
      className={classes(
        "overflow-hidden rounded-md border border-gray-200 bg-white",
        hasShadow && "shadow-sm",
        className,
      )}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

export default Card;
